<div :class="{'disabled': disabled}">
    <recurring v-if="canAccessRecurrency" v-model="recurring" @input="updateRecurring" :start-date="event.start_date" :disabled="disabled"/>
    <div class="notice-warning" v-else>
        <svg width="1em" class="svg-middle" viewBox="0 0 576 512" aria-hidden="true">
            <use xlink:href="@Assets/svg/symbol-defs.svg#exclamation-triangle"/>
        </svg>
        {{ $t('vm.root.calendar.event.recurrency.google') }}
    </div>
</div>